/* eslint-disable camelcase */

export default api => {
  function getInventoryStock(query) {
    return api.get(`/_svc/slapi-v1/inventory/tmp/stock-open${query}`);
  }

  function getInventoryWarehouse() {
    return api.get(`/_svc/slapi-v1/inventory/warehouses`);
  }

  return {
    getInventoryStock,
    getInventoryWarehouse
  };
};



// WEBPACK FOOTER //
// ./src/services/InventoryService.js